import { Grid } from "@mui/material";
import InfiniteLoaderGrid from "./InfininteLoaderGrid/InfiniteLoaderGrid";
const Reviewed = ({
  loadMoreItems,
  displayedMediaFiles,
  hasNoMore,
  activeTab,
  review_Media,
  handleReiewQuote,
  perPage,
  columns,
  draggableItem,
  columnCount = 5,
}) => {
  return displayedMediaFiles.length ? (
    <Grid container className="soContainer" spacing={1}>
      <InfiniteLoaderGrid
        loadMoreItems={loadMoreItems}
        items={displayedMediaFiles}
        hasNextPage={!hasNoMore}
        activeTab={activeTab}
        handleReviewMedia={review_Media}
        handleReiewQuote={handleReiewQuote}
        pageSize={perPage}
        approved={true}
        columnCount={columns || columnCount}
        draggableItem={draggableItem}
      />
    </Grid>
  ) : null;
};
export default Reviewed;
